import { SubscriptionPlanOption as PlanOptions } from '../../model/subscription-plan-option';

export function mapDtoToPlanOptions(dto: any): PlanOptions[] {
  return dto.map(
    (o: any): PlanOptions => ({
      value: o.id,
      label: `${o.type.charAt(0).toUpperCase()}${o.type.slice(1)} - ${o.interval.charAt(0).toUpperCase()}${o.interval.slice(1)}`,
      id: o.id,
      type: o.type,
      interval: o.interval,
      price: o.price,
      description: o.description,
    })
  );
}
